import EmailView from "./EmailView";
export default EmailView;